<template>
  <a
    href="https://crm.canis.marketing"
    target="_blank"
    title="Canis CRM"
  >
    <Logo
      height="14"
      alt="Canis CRM"
    />
  </a>
</template>

<script>
export default {
  name: 'ExternalLinkBaserowLogo',
}
</script>
